// @flow
import React from 'react';
import { FieldArray, getIn, useFormikContext } from 'formik';

import { If } from '../presentational/If';

import { ESTIMATE_COMMITTED_CAPACITY } from './enums';
import { CommittedCapacityDimensionsSingleRowForEstimateCC } from './CommittedCapacityDimensionsSingleRowForEstimateCC';
import { DimensionHeadersContainerForEstimateCC } from './dimensions/DimensionHeadersContainerForEstimateCC';

const DimensionRows = ({
  arrayHelpers,
  configuredDimensionRows,
  metricArrayHelpers,
  metricDimensionRefs,
  metricIndex,
  metricRow,
}) => {
  const metricName = metricRow.metricName;
  metricDimensionRefs.current.dimensionArrayHelpersMap[metricName] = arrayHelpers;
  return (
    <>
      <If test={configuredDimensionRows.length > 0}>
        <DimensionHeadersContainerForEstimateCC metricName={metricName} />
      </If>
      {configuredDimensionRows.map((row, index) => (
        <CommittedCapacityDimensionsSingleRowForEstimateCC
          dimensionArrayHelpers={arrayHelpers}
          dimensionIndex={index}
          key={`${row.id}-${index}`}
          metricArrayHelpers={metricArrayHelpers}
          metricIndex={metricIndex}
          metricRow={metricRow}
          row={row}
        />
      ))}
    </>
  );
};

export const CommittedCapacityDimensionsGridForEstimateCC = ({
  metricIndex,
  metricDimensionRefs,
  metricRow,
  metricArrayHelpers,
}) => {
  const { values: formikValues } = useFormikContext();
  const dimensionsPath = `${ESTIMATE_COMMITTED_CAPACITY.METRICS_LEVEL_CONFIGURATION_ARRAY}[${metricIndex}]["${ESTIMATE_COMMITTED_CAPACITY.METRICS_DIMENSIONS_LEVEL_CONFIGURATION_ARRAY}"]`;
  const configuredDimensionRows = getIn(formikValues, dimensionsPath) ?? [];

  return (
    <FieldArray
      name={dimensionsPath}
      render={(arrayHelpers) => (
        <DimensionRows
          arrayHelpers={arrayHelpers}
          configuredDimensionRows={configuredDimensionRows}
          metricArrayHelpers={metricArrayHelpers}
          metricDimensionRefs={metricDimensionRefs}
          metricIndex={metricIndex}
          metricRow={metricRow}
        />
      )}
    />
  );
};
